/**
 * Returns  Duaid and TraceId  to be logged for requests
 */
export const getTrackingInfoForLogging = (context): string => {
  const duaid = context && context.deviceId;
  const traceId = context && context.traceInfo && context.traceInfo['Trace-ID'];

  return ` DUAID=${duaid} , TraceID=${traceId}`;
};
